import { CandidateStatus, StatusSet } from 'generated-graphql/types';
import { candidateStatusOrder } from '../constants/candidateStatusOrder';
import { candidateStatusLabelMap } from 'services/candidate/utils/candidateStatusLabelMap';

const defaultCandidateStatusOptions = Object.values(CandidateStatus)
  .sort((a, b) => {
    return (candidateStatusOrder[a] || -1) - (candidateStatusOrder[b] || -1);
  })
  .map((status) => ({
    label: candidateStatusLabelMap[status],
    value: status
  }));

export const getStatusOptions = ({
  statusSet
}: {
  statusSet: StatusSet | null;
}) => {
  const extraCandidateStatusOptions =
    statusSet?.statuses.map((status) => ({
      label: status.label,
      value: status.value
    })) ?? [];

  return [...defaultCandidateStatusOptions, ...extraCandidateStatusOptions];
};
